import { InjectionToken } from "@angular/core";

export const TABLE_NESTED_CUSTOM_TEMPLATE_CONTEXT = new InjectionToken<{ [key: string]: any }>(
  "Context from nested table custom template"
);
